import { Component } from 'vue-property-decorator';
import { Page } from '../../helpers/components';
import { BasePage } from '../base-page';
import { apartmentLocationData } from './apartment-location.data';
import { WmsLayout } from '../../components/layout/layout';

@Page(WmsLayout, apartmentLocationData) @Component
export class ApartmentLocationPage extends BasePage {
}

export default ApartmentLocationPage;
